import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { CurrencyEnum } from '../../../../lib/enums/currency.enum';
import { OrderSideEnum } from '../../../../lib/enums/order-side.enum';
import lang from '../../../../lib/language';
import { FXSubscriptionService } from '../../../../lib/services/subscription/FXSubscription.service';
import { CurrencySymbolType } from '../../../../lib/services/subscription/types';
import { RootState } from '../../../../lib/store/index';
import { getToken } from '../../../../lib/store/selectors';
import FxState from '../../../../lib/store-util/FxState';
import { NullableString } from '../../../../lib/util/types';

import IconBuyEur from '../../../../assets/img/wallet/icon_buy_eur.svg';
import IconSellEur from '../../../../assets/img/wallet/icon_sell_eur.svg';
import { ButtonTypesEnum } from '../../../../components/Button/Button.types';
import { Button } from '../../../../components/index';

import styles from './ReviewFXExchange.module.scss';

type Props = {
    side: OrderSideEnum;
    eurAmount: string;
    usdAmount: string;
    handleConfirmOrder: () => void;
    handleCancel?: () => void;
}

const ReviewFXExchange = ({ side, eurAmount, usdAmount, handleCancel, handleConfirmOrder }: Props) => {
  const fxRateSymbol = CurrencySymbolType.EuroUSDollar;
  const fxState = FxState.useCustom(fxRateSymbol);
  const askPrice = fxState?.askPrice ?? 1;
  const bidPrice = fxState?.bidPrice ?? 1;

  const accessToken = useSelector<RootState, NullableString>((state: RootState) => getToken(state));

  useEffect(() => {
    const service = FXSubscriptionService.getInstance(accessToken!);
    service.subscribe(fxRateSymbol);

    return () => {
      service.unsubscribe(fxRateSymbol);
    };
  }, [fxRateSymbol, accessToken]);

  return (
    <>
      <div className={styles.wrapperContent}>
        <div className={styles.headerWrapper}>
          <img src={side === OrderSideEnum.Sell ? IconSellEur : IconBuyEur} alt="exchange icon" />
          <span>
            {side === OrderSideEnum.Sell ? lang.commonOrderSideButtonSell() : lang.commonOrderSideButtonBuy()}
            {' '}
            {CurrencyEnum.EUR}
          </span>
        </div>
        <div className={styles.row}>
          <div>{lang.walletExchangeing()}</div>
          <div>
            <span>-</span>
            {' '}
            <span>{side === OrderSideEnum.Sell ? eurAmount : usdAmount }</span>
          </div>
        </div>
        <div className={styles.row}>
          <div>{lang.commonTo()}</div>
          <div>
            <span>+</span>
            {' '}
            <span>{side === OrderSideEnum.Sell ? usdAmount : eurAmount}</span>
          </div>
        </div>
        <div className={styles.row}>
          <div>{lang.walletExchageRate(CurrencyEnum.EUR, CurrencyEnum.USD)}</div>
          <div>
            <span>≈</span>
            {' '}
            {side === OrderSideEnum.Sell ? bidPrice.toFixed(4) : askPrice.toFixed(4)}
          </div>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <Button fullWidth onClick={handleCancel && handleCancel} variant={ButtonTypesEnum.Tertiary}>
          {lang.commonCancelButton()}
        </Button>
        <Button fullWidth onClick={handleConfirmOrder}>{lang.walletExchangeConfirmBtn()}</Button>
      </div>
    </>
  );
};

export default ReviewFXExchange;
